import { css } from '@emotion/react';

export default $ => css`
  .card {
    border-radius: ${$.borderRadiusLg};

    &.square {
      border-radius: 0;
    }

    &.square-top {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &.square-bottom {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    > .card-header {
      border-radius: ${$.borderRadiusLg} ${$.borderRadiusLg} 0 0;

      .title {
        font-size: x-large;
        font-weight: bold;

        &.has-buttons {
          display: inline-block;
          vertical-align: bottom;
        }
      }

      .pagination {
        margin-bottom: 0;
      }
    }

    > .card-footer {
      border-radius: 0 0 ${$.borderRadiusLg} ${$.borderRadiusLg};
      .pagination {
        margin-bottom: 0;
      }
      &.pagination {
        padding-top: 0.35rem;
        padding-bottom: 0.35rem;
      }
    }

    &:not(:has(.card-header)) {
      > .card-body {
        border-radius: 0 0 ${$.borderRadiusLg} ${$.borderRadiusLg};
      }
    }
    &:not(:has(.card-footer)) {
      > .card-body {
        border-radius: 0 0 ${$.borderRadiusLg} ${$.borderRadiusLg};
      }
    }
    &:not(:has(.card-footer)):not(:has(.card-header)) {
      > .card-body {
        border-radius: ${$.borderRadiusLg};
      }
    }

    > table {
      > thead th {
        font-weight: normal;
      }
    }

    &.primary {
      background-color: ${$.gray100};
      color: ${$.black};
      > table {
        background-color: ${$.white};
        > thead * {
          color: ${$.primaryMain};
        }
        > tbody {
          > tr {
            margin-top: 5px;
            background-color: ${$.white};
          }
        }
      }
      > .card-header {
        color: ${$.white};
        background-color: ${$.primaryMain};
      }
    }

    &.info {
      > .card-header {
        background-color: ${$.infoMain};
      }
    }
  }

  .card.inbox-card {
    margin-bottom: ${$.mainContainerGap};
  }

  .no-bottom-gap {
    margin-bottom: 0 !important;
  }

  .dropdownOrganizationSelected {
    font-weight: 400;
    color: ${$.primaryMain} !important;
    border: 1px solid ${$.primaryMain};
    padding: 6px;
    border-radius: 5px;
    font-size: 12px;
    min-width: 220px;
    cursor: pointer;
  }
`;
